angular.module('ihestiaWidgets.policyDetails')
  .controller('ihestiaRestoreAnniversaryModalCtrl', ['$scope',
    function($scope) {
      $scope.tplData = $scope.helper.tplData;
      $scope.helper.init();
    }]);
